<template>
  <div class="multiselect__tag" v-bind="$attrs">
    <slot></slot>
    <i
      tabindex="1"
      @keydown.enter.prevent="remove(option)"
      @mousedown.prevent="remove(option)"
      class="multiselect__tag-icon"
    ></i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

/**
 * vue-multiselectのtagのレイアウトを変更する際に使うコンポーネント
 * classとかremove iconとか毎回書きたくない
 */
export default defineComponent({
  name: "MultiSelectTag",
  props: {
    option: {
      type: Object as PropType<unknown>,
      required: true,
    },
    remove: {
      type: Function as PropType<(option: unknown) => void>,
      required: true,
    },
  },
});
</script>
